export enum STORAGE_KEY {
  AUTH_STATE = 'auth_state',
  USER = 'user',
  ATO = 'ATO',
  RTO = 'RTO',
}
